import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Address, Country, Customer} from '~core/models';
import {StorageService} from '~core/services';
import {DuplicateCheckService} from "~features/create-customer/duplicate-check.service";

/**
 * Component for displaying the possible duplicates
 */
@UntilDestroy()
@Component({
  selector: 'app-duplicate-check',
  templateUrl: './duplicate-check.component.html',
  styleUrls: ['./duplicate-check.component.scss']
})
export class DuplicateCheckComponent implements OnInit, OnDestroy {
  public loading: boolean = true;
  public countries: Array<Country>;

  @Input() public customer: Customer;
  @Input() public address: Address;
  @Input() public listOfDuplicates: any;
  @Output() public openModal: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public duplicateCheckService: DuplicateCheckService,
    public storage: StorageService
  ) {
    this.storage.castCurrentCountries.pipe(untilDestroyed(this))
      .subscribe(countries => this.countries = countries);
  }

  /**
   * Executes country name replacement
   */
  public ngOnInit(): any {
    this.countryLoad(this.address);
  }

  public ngOnDestroy(): void {
  }

  /**
   * Replaces the country code with the country name
   */
  public countryLoad(address: Address): any {
    this.getCountry(address.country, address);
    this.loading = false;
    this.listOfDuplicates.forEach(duplicate => {
      duplicate.addresses.forEach(duplicateAddress => {
        this.getCountry(duplicateAddress.country, duplicateAddress);
      });
    });
  }

  /**
   * Opens up the confirm modal
   */
  public confirmModal(id: number): void {
    this.openModal.next(true);
    this.duplicateCheckService.selectedCustomerId = id;
  }

  /**
   * Get country by the locale.
   */
  public getCountry(key: any, finalArray: any): any {
    this.countries.filter(el => {
      if (el['iso2'] === key) {
        finalArray.country = el['name'];
      }
    });
  }

}
